// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__3DwGL","content":"GlobalSearch_content__2UPXx"};